<template>
    <div>
        <text-form-group
                :value="value.value"
                name="value"
                label="Value"
                :error="(errors.value || [])[0]"
                @input="input('value', $event)"
        />
    </div>
</template>

<script>
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        methods: {
            input(key, value) {
                this.$emit('input', {...this.value, [key]: value})
            }
        }
    }
</script>
